import React, { useState, Fragment } from "react";
import { Helmet } from "react-helmet";
import LoadingSpinner from "../../partials/loading";
import { Redirect } from "react-router-dom";
import * as Scanner from "instascan-v2";
import { GET_PATIENT_NHS } from "../../queries/patient.query";
import { useLazyQuery } from "@apollo/react-hooks";
import { appName } from "../../app.json";
import { SaveData } from "../../providers/Patient.Provider";

// custom css
import "./quick.css";
import auth from "../../providers/Auth.Provider";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";

function FetchPatient(props) {
    const redirect = "/home/patient/profile";
    /**
     * Create states
     */
    const [cameras, setCameras] = useState([]);
    const [activeCam, setActiveCamera] = useState(null);
    const [message, setMessage] = useState(null);
    const [sc, setSc] = useState(null);
    const [load, setLoad] = useState(false);

    // prepare query
    const [GetPatient, { loading, error, data }] = useLazyQuery(GET_PATIENT_NHS, {
        onCompleted: (data) => {
            localStorage.setItem("_active", JSON.stringify(data.GetPatientByNumber.doc));
            SaveData(data.GetPatientByNumber.doc);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    // Check if the error is authentication error; if true clear local storage and login user out
    if (error && auth.authProvider.IsAuthenticationError(error.message)) {
        auth.authProvider.LogOut();
        return (
            <Redirect
                to={{
                    pathname: `/login?redirect=${props.location.pathname}`,
                }}
            />
        );
    }

    // start the patient search
    const beginSearch = (input) => {
        setMessage(null);
        GetPatient({ variables: { hcn: input } });
    };

    const onScanStart = async (camera) => {
        const scanner = new Scanner.Scanner({
            video: document.getElementById("preview"),
        });
        setSc(scanner);
        try {
            // add scan listener
            scanner.addListener("scan", async (data) => await processContent(data));
            scanner.addListener("inactive", async () => {
                if (sc)
                    setTimeout(async () => {
                        await sc.stop();
                    }, 0);
            });
            await scanner.start(camera);
        } catch (err) {
            console.log("Scanner failed to start: ", err);
            toast.error("Scanner failed to start!");
            await scanner.stop();
        }
    };

    // get all camera on system
    const OnCamera = async () => {
        setLoad(true);
        const cameras = await Scanner.Camera.getCameras();
        setCameras(cameras);
        document.getElementById("scan").click();
        setLoad(false);
    };

    // Select a camera from scanner
    const OnSelectCamera = async (cam) => {
        if (!(activeCam && activeCam.id === cam.id)) {
            setActiveCamera(cam);
            setTimeout(async () => {
                await onScanStart(cam);
            }, 0);
        }
    };
    /**
     * Stop QRCode scanner
     */
    const onStopScanner = () => {
        sc.stop();
        setActiveCamera(null);
        document.getElementById("scan").click();
    };

    const processContent = async (content) => {
        setMessage(null);
        try {
            const result = JSON.parse(atob(content));
            if (typeof result === "object") {
                // check if object has id and app keys
                if ("id" in result && "app" in result) {
                    if (result.app === "igenie") {
                        document.getElementById("stop").click();
                        setTimeout(async () => {
                            await beginSearch(result.id);
                        }, 0);
                    }
                } else {
                    toast.error("Unknown QRCode!");
                }
            }
        } catch (error) {
            console.log("ERROR:", error);
            toast.error("Unknown QRCode!");
        }
    };

    if (data && data.GetPatientByNumber) {
        if (redirect.includes("/patient/profile")) {
            return (
                <Redirect
                    to={{
                        pathname: `${redirect}/${data.GetPatientByNumber.doc.id}`,
                    }}
                />
            );
        } else {
            return (
                <Redirect
                    to={{
                        pathname: redirect,
                        search: `?ref=${data.GetPatientByNumber.doc.id}`,
                    }}
                />
            );
        }
    }

    const title = "Search for patient";

    return (
        <Fragment>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body" style={{ minHeight: "400px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                            <div className="text-primary" style={{ fontSize: "2em" }}>
                                Scanner
                            </div>
                            <small>Their could be multiple camera depending on the host device.</small>

                            <button type="button" onClick={OnCamera} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-fault mt-3">
                                <i className="material-icons quick-heading text-primary">shutter_speed</i>
                                &nbsp; Start Scanner
                            </button>

                            {/* <h4>
                                <span className="material-icons text-primary">all_inclusive</span>
                            </h4>
                            <hr />
                            <div className="input-group mb-3 input-group-lg">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">
                                        <i className="material-icons text-primary">search</i>
                                    </span>
                                </div>
                                <input
                                    type="search"
                                    onChange={({ currentTarget: { value } }) => setKeyword(value)}
                                    name="keyword"
                                    className="form-control no-radius"
                                    placeholder="enter patient NHS Id .."
                                    aria-label="Patient NHS Id.."
                                    aria-describedby="basic-addon1"
                                />
                                <div className="input-group-append">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (keyword) {
                                                beginSearch(keyword);
                                            } else {
                                                toast.error("Please, enter patient's NHS number!", {
                                                    position: "bottom-right",
                                                });
                                            }
                                        }}
                                        style={{
                                            right: "-2px",
                                            borderRadius: "0 28px 28px 0",
                                        }}
                                        className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-success"
                                    >
                                        Search
                                    </button>
                                </div>
                            </div> */}

                            <LoadingSpinner loading={loading || load} bar={true} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="qrCodeModel" tabIndex="-1" role="dialog" aria-labelledby="codeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-min" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="codeModalLabel">
                                QRCode Scanner
                            </h4>
                            {!activeCam && (
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            )}
                        </div>
                        {activeCam && (
                            <div className="modal-body no-padding">
                                <video style={{ maxHeight: "max-content", maxWidth: "350px" }} id="preview"></video>
                                <div className="text-center m-t-10">
                                    <p className="text-danger">{message}</p>
                                </div>
                            </div>
                        )}

                        {!activeCam && (
                            <div className="modal-footer">
                                <h5>Select Camera to continue</h5>
                            </div>
                        )}
                        <div className="modal-footer mb-2">
                            {cameras.map((cam) => (
                                <button
                                    key={cam.id}
                                    type="button"
                                    onClick={() => OnSelectCamera(cam)}
                                    className={`mdl-button  mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle ${activeCam && activeCam.id === cam.id && "btn-success"}`}
                                >
                                    <i className="material-icons">camera</i>
                                    {cam.name}
                                </button>
                            ))}
                        </div>
                        {activeCam && (
                            <div className="modal-footer m-b-10">
                                <button onClick={() => onStopScanner()} type="button" id="stop" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect btn-circle">
                                    Stop
                                    <i className="material-icons text-danger">stop</i>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <input type="hidden" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#qrCodeModel" id="scan" />
        </Fragment>
    );
}

export default FetchPatient;
